import React from 'react';

import QueryPageTemplate from 'src/pages/QueryPages/components/QueryPageTemplate';
import { PATHS } from 'src/constants/config';

const Discarded = () => {
  return <QueryPageTemplate queryStatuses={['discarded', 'clientPassed']} title="Discarded" path={PATHS.QUERY_PROFILE.value} pageType="discarded" />;
};

export default Discarded;
